import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  List,
  Empty,
  Button,
  Toast,
  Card,
  InfiniteScroll,
} from 'antd-mobile';
import Recharge from "./Recharge";
import api from "../../api";
import "./style.less"

import BottomNavLayout from "../../components/BottomNavLayout";
import PubHeader from "../../components/PubHeader";

const Wallet = () => {
  const limit = 10;

  const params = useParams()
  const walletId = Number(params.walletId)

  const [wallet, setWallet] = useState()
  const [flowList, setFlowList] = useState([])
  const [hasMore, setHasMore] = useState(true)
  const [flowParams, setFlowParams] = useState({ limit, walletId })

  const [visible, setVisible] = useState(false)

  const title = walletId == 1 ? '会员卡详情' : 'IC卡详情'
  const cardNoDesc = walletId == 1 ? "" : `，卡号 ${wallet?.card?.cardNo}`
  const balanceTitle = walletId == 1 ? '会员卡余额' : `IC卡余额`

  const refreshUserWallet = async () => {
    const resp = await api.userWalletDetail({ walletId })
    setWallet(resp.data?.data)
  }

  const handleChargeClick = async () => {
    setVisible(true)
  }

  const handleChargeCallback = async (resp) => {
    setTimeout(() => {
      refreshUserWallet()
    }, 2000)
  }

  // 加载用户钱包资金记录列表
  // https://mobile.ant.design/zh/components/infinite-scroll#%E5%B1%9E%E6%80%A7
  const loadMore = async () => {
    const resp = await api.userWalletFlowList(flowParams);
    const flowListData = resp.data;

    if (!flowListData) {
      setHasMore(false)
      Toast.show({ content: '加载记录出错，请稍后再试' })
      return
    }

    if (flowListData.code !== 0) {
      setHasMore(false)
      Toast.show({ content: flowListData.message })
      return
    }

    const list = flowListData.data;
    if (list.length === 0) {
      setHasMore(false)
      return
    }

    let lastId = Number.MAX_VALUE;
    list.forEach(element => {
      if (element.id < lastId) {
        lastId = element.id
      }
    });
    setFlowParams({ lastId, limit, walletId })
    setFlowList(val => [...val, ...list])
  }

  useEffect(() => {
    refreshUserWallet()
  }, [walletId])


  return (
    <BottomNavLayout>
      <PubHeader title={title} />

      {wallet ?
        <div className="balance-wrapper">
          <Card>
            <div className="balance-info">
              <span>{wallet?.balance / 100}</span>
            </div>
            <div className="balance-title">
              <span>{balanceTitle}（包含赠送金额 {wallet?.giftBalance / 100}）</span>
            </div>
            <div className="charge-btn">
              <Button shape='rounded' color='default' fill='solid' onClick={() => handleChargeClick()}>
                立即充值
              </Button>
            </div>
          </Card>
        </div>
        : undefined
      }

      <div className="balance-flow-wrapper">
        <div className="flow-title">
          <span>余额记录{cardNoDesc}</span>
        </div>
        <div className="flow-list">
          {
            flowList.length === 0 ?
              <Empty description="哎呀，这里空空如也" />
              :
              <List mode='card'>
                {
                  flowList.map((item, index) => {
                    // 流水来源  1:订单 2:充值
                    // 流水类型  1:支付 2:退款
                    const amount = item.amount / 100

                    let listItem = ''
                    let extra = ''
                    if (item.source === 1) {
                      if (item.type === 1) {
                        listItem = '消费'
                        extra = '-' + amount
                      } else {
                        listItem = '退款'
                        extra = '+' + amount
                      }
                    } else {
                      listItem = '充值'
                      extra = '+' + amount
                    }

                    return <List.Item
                      key={index}
                      extra={<span className="flow-extra">{extra}</span>}
                      description={item.tradeTime}
                    >
                      {listItem}
                    </List.Item>
                  })
                }
              </List>
          }
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </div>
      </div>

      <div>
        <Recharge
          wallet={wallet}
          walletId={wallet?.id}
          visible={visible}
          setVisible={setVisible}
          payCallback={handleChargeCallback}
        />
      </div>
    </BottomNavLayout>
  )
}

export default Wallet